import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ExpertCard from './ExpertCard';
import { Row, Col, Input, Select, Button, Spin, Card, Pagination, message, Form, Typography } from 'antd';
import helpImg from '../../assets/images/expert/help.svg';
import { useNavigate } from 'react-router-dom';
import CustomSelect from '../common/customSelect';
import useResponsive from '../../hooks/useBreakpoint';
import ExpertSearchBox from '../common/ExpertSearchBox';
import { expertSeacrhParameters } from '../../helpers/constant';
import { getRequest } from '../../helpers/apiCall';
import { use } from 'react';
import { FrownOutlined } from '@ant-design/icons';

const { Search } = Input;

let filterParams = { search: '' };

const FindAnExpert = () => {
  const dispatch = useDispatch();
  const { locationList } = useSelector(state => state.common);
  const { expertListSearchParams, expertListWithSearchPagination, expertListWithSearchPaginationTotal, expertListWithSearchPaginationLoading, expertListWithSearchPaginationCurrentPage } = useSelector(state => state.expert);
  const navigate = useNavigate();
  const [page, setPage] = useState(expertListWithSearchPaginationCurrentPage || 1);
  const [searchParams, setSearchParams] = useState({});
  const [experts, setExperts] = useState(expertListWithSearchPagination || []);
  const [loading, setLoading] = useState(expertListWithSearchPaginationLoading || true);
  const [totalExperts, setTotalExperts] = useState(expertListWithSearchPaginationTotal || 0);
  function updateSearchParams(params) {

    Object.keys(params).forEach(key => {
      if (!params[key]) {
        delete params[key];
      }
    })
    setSearchParams(params);
    dispatch({ type: 'EXPERT_LIST_SEARCH_PARAMS', params: params });
  }
  useEffect(() => {
    if (!locationList.length) {
      dispatch({ type: 'GET_LOCATION_REQUEST', formData: { status: 'active' } });
    }
  }, [page]);
  useEffect(() => {
    dispatch({ type: 'RATE_TYPE_LIST_REQUEST' });
    dispatch({ type: 'GET_SERVICE_CATEGORY_REQUEST', formData: { status: 'active' } });

  }, [])
  useEffect(() => {
    if (searchParams?.category_id) {
      dispatch({
        type: 'QUESTION_SUB_CATEGORY_REQUEST',
        formData: { parent_id: searchParams?.category_id, per_page: 'all' },
      });
    }

  }, [searchParams?.category_id])
  useEffect(() => {
    setSearchParams(expertListSearchParams);
  }, [])
  const onExpertCardClick = item => {
    navigate(`/find-expert-detail/${item.id}`, {
      state: item,
    });
  };

  const breakpoint = useResponsive();
  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a style={{ color: 'rgb(28, 100, 242)', backgroundColor: 'white', padding: '5px 10px', borderRadius: '5px' }}>{"< Previous"}</a>;
    }
    if (type === 'next') {
      return <a style={{ color: 'rgb(28, 100, 242)', backgroundColor: 'white', padding: '5px 10px', borderRadius: '5px' }}>{"Next >"}</a>;
    }
    return originalElement;
  };
  const handleSearchFilter = async (fromRemoveFilter = false, fromSearchFilter = false) => {
    if (fromRemoveFilter) {
      dispatch({ type: 'EXPERT_LIST_SEARCH_WITH_PAGINATION', payload: { page: 1 } });
      setLoading(true);
      return
    }
    if (fromSearchFilter) {
      let payload = expertListSearchParams;
      payload['page'] = 1;
      dispatch({ type: 'EXPERT_LIST_SEARCH_WITH_PAGINATION', payload });
      setLoading(true);
      return
    }
    let payload = expertListSearchParams;
    payload['page'] = page;
    dispatch({ type: 'EXPERT_LIST_SEARCH_WITH_PAGINATION', payload });
    setLoading(true);
  }
  useEffect(() => {
    if (page !== expertListWithSearchPaginationCurrentPage) {
      // handleSearchFilter();
    }

  }, [page])
  useEffect(() => {
    if (!searchParams.search && !searchParams.location_id && !searchParams.category_id && !searchParams.sub_category_id && !searchParams.rate_type_id && !searchParams.pricing_range_from && !searchParams.pricing_range_to && page !== expertListWithSearchPaginationCurrentPage) {
      handleSearchFilter();
    }
  }, [searchParams, page])
  useEffect(() => {
    setExperts(expertListWithSearchPagination);
    setTotalExperts(expertListWithSearchPaginationTotal);
    setLoading(expertListWithSearchPaginationLoading);
  }, [expertListWithSearchPagination, expertListWithSearchPaginationLoading, expertListWithSearchPaginationTotal])
  return (
    <div className="padding-around find-expert" >
      <div className={breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm' ? '' : 'mt35'}></div>

      {loading && (
        <div style={{ width: breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm' ? '100%' : '75%', height: '100%' }} className="d-flex-a-c">
          <Spin />
        </div>
      )}
      <Row className="mt5" gutter={breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm' ? [10, 10] : [30, 30]} >
        {
          (breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm') && <>
            {
              expertSeacrhParameters.map((item) => {
                return <Col xs={item.key == 'search' ? 24 : 12} sm={item.key == 'search' ? 24 : 12} md={item.key == 'search' ? 24 : 12} lg={item.key == 'search' ? 24 : 12}  >
                  <ExpertSearchBox item={item} updateSearchParams={updateSearchParams} searchParams={searchParams} />
                </Col>
              })
            }
            <Button

              style={{ width: '100%', }}
              size="large"
              className=""
              disabled={!searchParams.search && !searchParams.location_id && !searchParams.category_id && !searchParams.sub_category_id && !searchParams.rate_type_id && !searchParams.pricing_range_from && !searchParams.pricing_range_to}
              onClick={() => {

                setSearchParams({
                  search: '',
                  location_id: '',
                  category_id: '',
                  sub_category_id: '',
                  rate_type_id: '',
                  pricing_range_from: '',
                  pricing_range_to: ''
                })
                handleSearchFilter(true, false);
              }
              }

            >
              Remove Filters
            </Button>
            <Button
              type='primary'
              style={{ width: '100%', }}
              size="large"
              className=""
              disabled={!searchParams.search && !searchParams.location_id && !searchParams.category_id && !searchParams.sub_category_id && !searchParams.rate_type_id && !searchParams.pricing_range_from && !searchParams.pricing_range_to}
              onClick={() => handleSearchFilter(false, true)}

            >
              Search
            </Button>
          </>

        }

        <>
          <Col xs={24} sm={24} md={24} lg={24} xl={18} xxl={18} >
            <Row gutter={[30, 30]} style={{}}>
              {experts?.length > 0 ?


                experts?.map(item => (
                  <ExpertCard item={item} onClick={() => onExpertCardClick(item)} />
                )) :

                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>{
                  !loading && <>
                    <FrownOutlined style={{ fontSize: '50px', color: '#1890ff' }} />

                    <Typography.Text type="secondary" color='#1890ff'>No expert found</Typography.Text>
                  </>
                }

                </div>}
            </Row>
          </Col>
        </>

        {
          (breakpoint == 'lg' || breakpoint == 'md' || breakpoint == 'xs' || breakpoint == 'sm') && <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ display: 'flex', justifyContent: 'end', width: 'auto' }}>
            <Pagination itemRender={itemRender} style={{ display: 'flex', justifyContent: 'end', width: 'auto', backgroundColor: 'rgb(28, 100, 242)', padding: '10px', color: 'white' }}
              disabled={loading} total={totalExperts}
              defaultCurrent={page} pageSize={20} onChange={(e) => setPage(e)} />
          </Col>
        }
        <Col xs={24} sm={24} md={24} lg={24} xl={6} xxl={6} >
          <Card className="find-card">
            <div>
              <img loading='lazy' alt="expert" className="main-img" src={helpImg} />
              <div className="card-section mt-5">
                <p className="help-title">Need Help</p>
                <p className="sub-title">
                  Not sure which expert is right for you? Our team will review your request and recommend the best match
                </p>
                <Button
                  style={{ width: '100%' }}
                  type="primary"
                  htmlType="submit"
                  size="large"
                  className=""
                  onClick={() => navigate('/request')}
                >
                  Get Help!
                </Button>
              </div>
            </div>
          </Card>

          {
            (breakpoint == "xl" || breakpoint == "xxl") &&

            <>
              {
                expertSeacrhParameters.map((item) => {
                  return <ExpertSearchBox item={item} updateSearchParams={updateSearchParams} searchParams={searchParams} />
                })
              }
              <Button

                style={{ width: '100%', marginTop: '20px' }}
                size="large"
                className=""
                disabled={!searchParams.search && !searchParams.location_id && !searchParams.category_id && !searchParams.sub_category_id && !searchParams.rate_type_id && !searchParams.pricing_range_from && !searchParams.pricing_range_to}
                onClick={() => {

                  setSearchParams({
                    search: '',
                    location_id: '',
                    category_id: '',
                    sub_category_id: '',
                    rate_type_id: '',
                    pricing_range_from: '',
                    pricing_range_to: ''
                  });
                  dispatch({
                    type: 'EXPERT_LIST_SEARCH_PARAMS', params: {
                      search: '',
                      location_id: '',
                      category_id: '',
                      sub_category_id: '',
                      rate_type_id: '',
                      pricing_range_from: '',
                      pricing_range_to: ''
                    }
                  });
                  handleSearchFilter(true, false);
                }}

              >
                Remove Filters
              </Button>
              <Button
                type='primary'
                style={{ width: '100%', marginTop: '10px' }}
                size="large"
                className=""
                disabled={!searchParams.search && !searchParams.location_id && !searchParams.category_id && !searchParams.sub_category_id && !searchParams.rate_type_id && !searchParams.pricing_range_from && !searchParams.pricing_range_to}
                onClick={() => handleSearchFilter(false, true)}

              >
                Search
              </Button>
            </>


          }

        </Col>
        {(breakpoint == 'xl' || breakpoint == 'xxl') &&
          <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ display: 'flex', justifyContent: 'end', width: 'auto' }}>
            <Pagination itemRender={itemRender} style={{ display: 'flex', justifyContent: 'end', width: 'auto', backgroundColor: 'rgb(28, 100, 242)', padding: '10px', color: 'white' }}
              disabled={loading} total={totalExperts}
              defaultCurrent={page} pageSize={20} onChange={(e) => setPage(e)} />
          </Col>
        }

      </Row>
    </div>
  );
};

export default FindAnExpert;
